@let d = data();
@if (d) {
  <div class="tp-header-wrapper">
    <div class="tp-header">
      <div class="tp-inventory">
        {{ d.inventoryNumber }}
        @if (d.isElectric && d.stateOfCharge) {
          <div class="tp-charge" [title]="batteryTitle()">
            @if (showBatteryQuestionMark()) {
              <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M5.5 1C5.06324 1.58142 4.75059 2.26109 4.60059 3H2.5C2.225 3 2 3.225 2 3.5V10.5C2 10.775 2.225 11 2.5 11H7.62891C7.38958 11.3575 7.25 11.7875 7.25 12.25C7.25 12.5133 7.29775 12.7652 7.38086 13H2.5C1.11875 13 0 11.8813 0 10.5V3.5C0 2.11875 1.11875 1 2.5 1H5.5ZM15.5 1C16.8813 1 18 2.11875 18 3.5V5C18.5531 5 19 5.44688 19 6V8C19 8.55312 18.5531 9 18 9V10.5C18 11.8813 16.8813 13 15.5 13H11.6191C11.7023 12.7652 11.75 12.5133 11.75 12.25C11.75 11.7875 11.6104 11.3575 11.3711 11H15.5C15.775 11 16 10.775 16 10.5V3.5C16 3.225 15.775 3 15.5 3H14.3994C14.2494 2.26109 13.9368 1.58142 13.5 1H15.5Z" fill="black"/>
                <path d="M9.5 0.849609C11.5095 0.849609 13.1502 2.40184 13.1504 4.33301C13.1504 5.89007 12.0838 7.19956 10.6201 7.64844L10.6211 7.64941C10.5145 7.68267 10.4301 7.73763 10.3848 7.78516C10.3626 7.80853 10.3544 7.82372 10.3516 7.83008C10.3493 7.8352 10.3496 7.83534 10.3496 7.83301V8.33301C10.3496 8.79141 9.96305 9.15039 9.5 9.15039C9.03695 9.15039 8.65039 8.79141 8.65039 8.33301V7.83301C8.65057 6.877 9.45183 6.2942 10.1016 6.09375C10.8887 5.85075 11.4502 5.15058 11.4502 4.33301C11.45 3.31864 10.5834 2.4834 9.5 2.4834C8.4166 2.4834 7.54999 3.31864 7.5498 4.33301C7.5498 4.79135 7.16316 5.15029 6.7002 5.15039C6.23715 5.15039 5.84961 4.79141 5.84961 4.33301C5.84979 2.40184 7.4905 0.849609 9.5 0.849609Z" fill="#FF3049" stroke="#FF3049" stroke-width="0.3"/>
                <circle cx="9.50001" cy="12.3" r="1.3" fill="#FF3049"/>
              </svg>
            } @else {
              <i [class]="batteryIconClass()" aria-hidden="true"></i>
              {{ d.stateOfCharge!.sensorValue }}%
            }
          </div>
        }
      </div>
      @if (d.deviationText) {
        <div class="tp-punctuality">
          {{ d.deviationText | translate }}
          @if ((d.deviationMinutes ?? 0) > 0) {
            &nbsp;{{ d.deviationMinutes }}min
          }
          <div class="tp-punctuality-dot" [style.background-color]="d.deviationColor"></div>
        </div>
      }
    </div>
  </div>

  <div class="tp-content">
    @if (d.currentActivity) {
      <div class="tp-activity-section">
        {{ 'Activities' | translate }}
        <div class="tp-activities-wrapper">
          <div class="tp-activity">
            <div class="tp-chip" [style.background-color]="getActivityColor(d.currentActivity.type)">
              {{ d.currentActivity.type }}
            </div>
            @if (d.currentActivity.routeName && d.currentActivity.tripNumber) {
              <div class="tp-line-trip">
                <div class="tp-line">{{ d.currentActivity.routeName }}</div>
                <div class="tp-trip">{{ d.currentActivity.tripNumber }}</div>
              </div>
            }
            <div class="tp-activity-text">
              @if (d.currentActivity.tripDescription) {
                <span class="tp-caption-bold">{{ d.currentActivity.tripDescription }}</span>
              }
              <span class="tp-caption">{{ d.currentActivity.startTime }}-{{ d.currentActivity.endTime }}</span>
            </div>
          </div>
          @if (d.nextActivity) {
            <div class="tp-activity">
              <div class="tp-chip" [style.background-color]="getActivityColor(d.nextActivity.type)">
                {{ d.nextActivity.type }}
              </div>
              @if (d.nextActivity.routeName && d.nextActivity.tripNumber) {
                <div class="tp-line-trip">
                  <div class="tp-line">{{ d.nextActivity.routeName }}</div>
                  <div class="tp-trip">{{ d.nextActivity.tripNumber }}</div>
                </div>
              }
              <div class="tp-activity-text">
                @if (d.nextActivity.tripDescription) {
                  <span class="tp-caption-bold">{{ d.nextActivity.tripDescription }}</span>
                }
                <span class="tp-caption">{{ d.nextActivity.startTime }}-{{ d.nextActivity.endTime }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    } @else if (d.activitiesFailed) {
      <div class="tp-loading tp-loading--failed">{{ 'Activities failed to load' | translate }}</div>
    } @else if (d.activitiesLoading) {
      <div class="tp-loading">{{ 'Loading activities' | translate }}…</div>
    }
    @if (d.warnings?.length) {
      <div class="tp-warnings-section">
        {{ 'Warnings' | translate }}
        <div class="tp-warnings-wrapper">
          @for (w of d.warnings!; track $index) {
            <div class="tp-warning">
              <i [class]="getWarningIconClass(w.messageType)" aria-hidden="true"></i>
              {{ getWarningMessage(w) }}
            </div>
          }
        </div>
      </div>
    }
  </div>
}
